<template>
  <div>
    <div v-if="patient">
      <b-card no-body class="card-padding">
        <b-form>
          <b-row>
            <b-col cols="1">
            </b-col>
            <filter-age-select
              :ageFrom="form.ageFrom"
              :ageTo="form.ageTo"
              @input="ageHandler"
              :labelCols="3"
              class="small-padding"
            ></filter-age-select>
            <filter-checkbox :label="$t('Поиск по DPB')" v-model="form.searchInDpb"></filter-checkbox>
            <filter-select
              :label="$t('Совместимость не хуже')"
              :cols="2"
              :labelCols="4"
              v-model="form.coincidence"
              :withoutEmpty="true"
              :options="coincidences()"
              class="small-padding"
            ></filter-select>
            <filter-select
              :cols="2"
              :labelCols="3"
              :label="$t('Пол')"
              v-model="form.gender"
              :options="genders"
              class="small-padding"
            ></filter-select>
            <filter-select
              :cols="1"
              :labelCols="3"
              :label="$t('Группа крови')"
              v-model="form.bloodType"
              :options="patient.bloodTypes"
              class="small-padding"
            ></filter-select>
            <filter-select
              :cols="1"
              :labelCols="3"
              :label="$t('Резус фактор')"
              v-model="form.rh"
              :options="patient.rhs"
              class="small-padding"
            ></filter-select>
            <filter-input
              :cols="1"
              :labelCols="2"
              label="ID"
              v-model="form.externalId"
              class="small-padding"
              :min="0"
              type="number"
            ></filter-input>
          </b-row>
          <b-row class="no-gutters">
            <b-col cols="1">
              <b-button
                v-on:click="resetForPatient"
                size="sm"
                variant="default"
              >
                <font-awesome-icon icon="times" />
                {{ $t('Сброс') }}
              </b-button>
            </b-col>
            <b-col cols="1" class="col-form-label">
              <b>{{ $t('Фенотип') }}</b>
            </b-col>
            <b-col v-for="item in sortedHlas" :key="item.hlaTypeValue">
              <b-form-group>
                <b-row>
                  <b-col cols="5" style="padding: 0;">
                    <b-form-input
                      v-mask="{ mask: '(9{2}:A{2,5})|(9{2}:9{2,3}[A]:9{2}[A])' }"
                      v-model="item.firstAllele"
                      :disabled="true"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="5" style="padding: 0;">
                    <b-form-input
                      v-mask="{ mask: '(9{2}:A{2,5})|(9{2}:9{2,3}[A]:9{2}[A])' }"
                      v-model="item.secondAllele"
                      :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
    <div v-else>
      <b-card-group>
        <b-card no-body>
          <div class="card-body">
            <div>
              <b-form>
                <b-row>
                  <b-col cols="1">
                    <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                      <font-awesome-icon icon="times" />
                      {{ $t('Сброс') }}
                    </b-button>
                  </b-col>
                  <filter-select
                    :cols="1"
                    :label="$t('Код РР')"
                    :disabled="$auth.user().isLr"
                    v-on:onChange="search"
                    v-model="form.lrOrganizationId"
                    :options="lrOrganizations"
                  ></filter-select>
                  <filter-input
                    label="ID "
                    v-on:onBlur="search"
                    :cols="1"
                    v-model="form.externalId"
                    :min="0"
                    type="number"
                  ></filter-input>
                  <filter-input
                    v-if="$auth.user().isRdkm && hasIon()"
                    label="GRID "
                    v-on:onBlur="search"
                    :cols="3"
                    v-model="form.grid"
                    :min="0"
                    type="number"
                  ></filter-input>
                  <filter-select
                    :label="$t('Статус')"
                    v-model="form.state"
                    :cols="2"
                    v-on:onChange="search"
                    :options="states"
                  ></filter-select>
                  <filter-input
                    v-if="!$auth.user().isRdkm"
                    :disabled="true"
                    :label="$t('Локальный регистр')"
                    v-model="organization"
                  ></filter-input>
                  <filter-checkbox 
                    :label="$t('Удаленные доноры')"
                     v-model="form.showDeleted"
                     v-on:onChange="changeIsDeleted"
                  ></filter-checkbox>
                </b-row>
              </b-form>
            </div>
          </div>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import BaseFilter from '@/models/base.filter';

export default {
  extends: BaseFilter,
  name: 'filter-form',
  props: [
    'patientId',
    'patient',
    'ageFrom',
    'ageTo',
    'coincidence',
    'gender',
    'searchInDpb',
    'showDeleted',
    'donorStatus',
    'operatorId',
    'externalId',
    'lrOrganizationId',
    'state'
  ],
  data() {
    return {
      form: {
        ageFrom: 18,
        ageTo: 65,
        showDeleted: this.showDeleted == 'true' || false,
        coincidence: 10,
        gender: this.gender || null,
        searchInDpb: this.searchInDpb || false,
        bloodType: this.bloodType || null,
        rh: this.rh || null,
        donorStatus: this.donorStatus || null,
        operatorId: this.operatorId || null,
        externalId: this.externalId || '',
        lrOrganizationId: this.lrOrganizationId || null,
        state: this.state || null
      },
      organization: `${this.$auth.user().currentOrganization.name} (${
        this.$auth.user().currentOrganization.code
      })`,
      states: [],
      operators: [],
      genders: [],
      bloodTypes: [],
      rhs: [],
      lrOrganizations: [],
    };
  },
  watch: {
    ageFrom: function() {
      this.form.ageFrom = this.ageFrom;
    },
    ageTo: function() {
      this.form.ageTo = this.ageTo;
    },
    coincidence: function() {
      this.form.coincidence = this.coincidence;
    },
    donorStatus: function() {
      this.form.donorStatus = this.donorStatus;
    },
    state: function() {
      this.form.state = this.state;
    },
    operatorId: function() {
      this.form.operatorId = this.operatorId;
    },
    externalId: function() {
      this.form.externalId = this.externalId;
    },
    patient: function() {
      if (this.patientId && this.patient && this.patient.status != 2) {
        Swal(
          '',
          this.$t('Для отправки доноров в ЛР необходим статус пациента Поиск донора'),
          'info'
        );
      }
    },
  },
  methods: {
    hasIon() {
      return window.ion;
    },
    changeIsDeleted() {
      this.form.showDeleted = !this.form.showDeleted;
      this.$emit('changeDeletedFilter', this.form.showDeleted);
      this.search();
    },
    getDictionaries() {
      if (!this.patient) {
        axios
          .get('/Donors/GetStates')
          .then((response) => {
            this.states = response.data;
          })
          .catch((w) => {});

        const orgId = this.$auth.user().isLr
          ? this.$auth.user().lrId ||
            this.$auth.user().impersonateOrganizationId ||
            this.$auth.user().organizationId
          : null;

        axios
          .get('/Dictionary/GetOperators?group=3&organizationId=' + orgId)
          .then((response) => {
            this.operators = response.data;
          })
          .catch((w) => {});

        axios
          .get('/Dictionary/GetLrOrganizationCodes')
          .then((response) => {
            this.lrOrganizations = response.data;
          })
          .catch(() => {});
      } else {
        axios
          .get('/Dictionary/GetGenders')
          .then((response) => {
            this.genders = response.data;
          })
          .catch((w) => {});
      }
    },
    search: function() {
      this.$emit('search', {
        state: this.form.state,
        operatorId: this.form.operatorId,
        grid: this.form.grid,
        externalId: this.form.externalId,
        showDeleted: this.form.showDeleted,
        lrOrganizationId: this.form.lrOrganizationId,
      });
    },
    searchForPatient: function() {
      this.$emit('search', {
        ageFrom: this.form.ageFrom,
        ageTo: this.form.ageTo,
        coincidence: this.form.coincidence,
        gender: this.form.gender,
        rh: this.form.rh,
        bloodType: this.form.bloodType,
        externalId: this.form.externalId,
        searchInDpb: this.form.searchInDpb,
      });
    },
    reset() {
      this.$emit('reset');
      this.form = {
        state: null,
        externalId: null,        
      };
      if (this.$auth.user().isLr) {
        this.form.lrOrganizationId = this.$auth.user().currentOrganization.id;
      }

      this.search();
    },
    resetForPatient: function() {
      this.$emit('reset');
      this.form.ageFrom = 18;
      this.form.ageTo = 65;
      this.form.coincidence = 10;
      this.form.externalId = '';
      this.form.gender = null;
      this.form.searchInDpb = false;
    },
    ageHandler(e) {
      this.form.ageFrom = e.ageFrom;
      this.form.ageTo = e.ageTo;
    },
    coincidences() {
      let max = this.form.searchInDpb ? "12" : "10";
      let result = [
                { value: '7/' + max, key: 7 },
                { value: '8/' + max, key: 8 },
                { value: '9/' + max, key: 9 },
                { value: '10/' + max, key: 10 }
              ];
      if(this.form.searchInDpb) {
        result.push({ value: '12/12', key: 12 });
      }
      return result;
    },
  },
  computed: {
    sortedHlas: function() {
      if (!this.patient || !this.patient.hlas) return [];

      let sorted = this.patient.hlas.slice();
      sorted.forEach(function(val) {
        if (val.hlaTypeName == 'DQB1*') {
          val.sortValue = val.hlaTypeValue + 1;
        } else if (val.hlaTypeName == 'DRB1*') {
          val.sortValue = val.hlaTypeValue - 1;
        } else {
          val.sortValue = val.hlaTypeValue;
        }
      });
      sorted.sort(function(a, b) {
        return a.sortValue - b.sortValue;
      });
      return sorted;
    },

    common: function() {
      const arr = [this.fullName, this.birthday, this.diagnosis];

      if (this.$auth.user().isRdkm) {
        arr.push(this.tc);
      }

      let result = '';
      arr.forEach(function(element) {
        if (element) {
          result += '. ' + element;
        }
      });
      if (result) {
        result = result.substring(2);
      }
      return result;
    },

    fullName: function() {
      if (!this.patient) return '';

      const arr = [
        this.patient.lastName,
        this.patient.firstName,
        this.patient.middleName,
      ];
      let result = '';
      arr.forEach(function(element) {
        if (element) {
          if (result) {
            result += ' ';
          }
          result += element;
        }
      });
      return result;
    },

    birthday: function() {
      if (!this.patient) return '';

      if (!this.patient.birthday) {
        return '';
      }
      return (
        '<b>' + this.$t('Дата рождения') + ': </b>' +
        moment(new Date(this.patient.birthday)).format('DD.MM.YYYY')
      );
    },

    diagnosis: function() {
      return '<b>' + this.$t('Диагноз') + ': </b>' + this.diagnosisName;
    },

     diagnosisName: function() {
      if (!this.patient || !this.patient.diagnosis) {
        return '';
      }

      return this.patient.diagnosis;
    },

    tc: function() {
      if (!this.patient) return '';

      return '<b>' + this.$t('ТЦ') + ': </b>' + this.patient.organizationCode;
    },
  },
};
</script>

<style scoped>
.small-padding {
  padding-right: 0px;
  padding-left: 5px;
}

.card-padding {
  padding: 5px 20px 0px 5px;
}
</style>
